<template>
<div>
     <v-navigation-drawer :width="( id == 3) ? 0 : width" permanent>
          <v-list>
               <template v-for="item in items">

                    <v-list-group v-if="item.children && item.currentComponent =='siteweb'" :key="item.title" color="primary" class="listGroup" :prepend-icon="item.icon">

                         <template v-slot:activator>
                              <v-list-item>
                                   <v-list-item-content>
                                        <v-list-item-title>
                                             {{ $t(item.title) }}
                                        </v-list-item-title>
                                   </v-list-item-content>
                              </v-list-item>
                         </template>

                         <v-list-item dense nav v-for="(child, i) in item.children" class="mx-0 " :key="i" @click="changeComponent(child,item.id)">
                              <v-list-item-icon color="amber accent-1">
                                   <template>
                                        <v-icon class="mx-3" style="font-size: 20px !important;" large>{{ localLang == "fr" ? 'mdi-arrow-right-bold' : 'mdi-arrow-left-bold' }}</v-icon>
                                   </template>
                              </v-list-item-icon>
                              <v-list-item-content>
                                   <v-list-item-title style="color: #72777C; font-size: 15px">
                                        {{ getNameSection(child.id) }}
                                   </v-list-item-title>
                              </v-list-item-content>
                         </v-list-item>

                    </v-list-group>

               </template>
               <v-list-item-group v-model="i" color="primary">
                    <template v-for="(item, i) in items">
                         <v-list-item v-if=" item.currentComponent == 'message'" :key="i" @click="changeComponent2(item.id)">
                              <v-list-item-icon color="amber accent-1">
                                   <template>
                                        <v-icon style="font-size: 25px !important;" large>{{ item.icon }}</v-icon>
                                   </template>
                              </v-list-item-icon>
                              <v-list-item-content class="mx-0">
                                   <v-list-item-title>
                                        {{ $t(item.title) }}
                                   </v-list-item-title>
                              </v-list-item-content>
                         </v-list-item>
                    </template>
               </v-list-item-group>

          </v-list>
          <div id="selectMove" class="selectMove" @mousedown="getResize"></div>
     </v-navigation-drawer>
</div>
</template>

<script>
export default {
     props: {
          items: {
               type: Array,
               required: true
          },
          id: {
               type: Number
          }
     },
     data() {
          return {
               i: 0,
               prevX: 0,
               width: screen.width <= 1152 ? 65 : 210,
          }
     },
     created() {
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
     },
     methods: {
          /***************************************** */
          checkDefaultSection(id) {
               for (let i = 0; i < this.sections.length; i++) {
                    if (this.sections[i].id == id) {
                         return this.sections[i]
                    }
               }
          },
          getNameSection(id) {
               return this.localLang == "fr" ? (this.checkDefaultSection(id).nameFr ? this.checkDefaultSection(id).nameFr : '') : (this.checkDefaultSection(id).nameAr ? this.checkDefaultSection(id).nameAr : '')
          },
          /*************************************** */
          changeComponent(child, idPage) {
               Fire.$emit('changeComponent', child, idPage)
          },
          changeComponent2(idPage) {
               Fire.$emit('changeComponent2', idPage)
          },
          getResize(e) {
               this.prevX = e.clientX
               window.addEventListener("mousemove", this.mousemove)
               window.addEventListener("mouseup", this.mouseup)
          },
          mousemove(e) {
               this.width += (e.clientX - this.prevX)
               this.prevX = e.clientX
          },
          mouseup() {
               window.removeEventListener("mousemove", this.mousemove)
               window.removeEventListener("mouseup", this.mouseup)
          }
     },
}
</script>

<style scoped>
.selectMove {
     margin-right: 7px !important;
     width: 4px;
     background: transparent;
     height: 100%;
     position: absolute;
     right: -6px;
     top: 0;
     cursor: w-resize;
}

.v-list-group__header__prepend-icon {
     margin-right: 10px !important
}
</style><style>
.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
     min-width: 0px !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
     margin-right: 10px !important;
}

.v-application--is-rtl .v-list-item__action:first-child,
.v-application--is-rtl .v-list-item__icon:first-child {
     margin-left: 10px !important;
}
</style>
